import { CURRENT_PAGE, CHANGE_PAGE } from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case CURRENT_PAGE:
            return {
                ...state
            }
        case CHANGE_PAGE:
            return {
                page: action.payload
            }
        default:
            return state;
    }
}